import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../api/services/auth.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {
  usernameNotFound: boolean;
  submitted = false;

  constructor(private authService: AuthService) { }

  ngOnInit() {
  }

  submit(username: string) {
    this.usernameNotFound = false;
    this.authService.resetPassword(username).subscribe(() => {
      this.submitted = true;
    }, error => {
        this.usernameNotFound = true;
    });
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/forgot-password/forgot-password.component.ts